import { FC } from 'react';
import { Badge } from '../components/Badge';
import { CaregiverIcon } from '../theme/Icons';

export type IPrimaryCaregiverBadge = {
    primaryCaregiver?: boolean;
    iconOnly?: boolean;
};

export const PrimaryCaregiverBadge: FC<IPrimaryCaregiverBadge> = ({ primaryCaregiver, iconOnly }) => {
    return (
        primaryCaregiver && (
            <Badge color="theme-indigo" size="small" data-type="primary-caregiver-badge" borderRadius={iconOnly ? 16 : undefined}>
                <div style={{display: iconOnly ? undefined : 'flex'}}>
                    <CaregiverIcon color="theme-indigo" />
                    {!iconOnly && <div style={{marginTop: 3}}>&nbsp;&nbsp;Primary Caregiver</div>}
                </div>
            </Badge>
        )
    );
};
